export const getInitials = (m) => {
    const first = (m?.firstName || "").trim();
    const last  = (m?.lastName || "").trim();
  
    if (first || last) {
      return `${first[0] || ""}${last[0] || ""}`.toUpperCase() || "?";
    }
  
    const email = (m?.email || "").trim();
    if (email) return email[0].toUpperCase();
  
    return "?";
  };
  